import { useCallback } from 'react';
import { invalidateGscIntegrationHealth, useGSCConnectIntegration } from '#entities/integration';
import { showError } from '#shared/lib/toast';
import { useGscSiteVerificationStatus } from './useGscSiteVerificationStatus';

export const useGscConnectionActions = () => {
    const status = useGscSiteVerificationStatus();
    const { isConnecting, handleConnect } = useGSCConnectIntegration({
        onSuccess: status.refetchAutomaticStatus,
    });

    const connectAutomatically = useCallback((): boolean => {
        if (!status.isSitePublished) {
            showError({ label: 'Сначала подключите домен магазина' });

            return false;
        }

        handleConnect();

        return true;
    }, [handleConnect, status.isSitePublished]);

    const saveVerificationCode = useCallback(
        async (verificationCode: string): Promise<boolean> => {
            const normalizedCode = verificationCode.trim();

            if (!normalizedCode || !status.setting) {
                if (!status.setting) {
                    showError({ label: 'Не удалось загрузить настройку кода верификации' });
                }

                return false;
            }

            const isSaved = await status.setting.patch(normalizedCode);

            if (isSaved) {
                invalidateGscIntegrationHealth();
            }

            return isSaved;
        },
        [status.setting]
    );

    return {
        ...status,
        connectAutomatically,
        isConnecting,
        saveVerificationCode,
    };
};
